import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Reseller route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with properties
 * used by navigation guards and permission checks.
 *
 * @typedef {Object} ResellerRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/resellers",
        name: "Resellers",
        meta: {
            title: "Resellers",
            modules: ["RESELLERS"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },

        component: () =>
            import(
            /* webpackChunkName: "resellers" */ "@/modules/resellers/pages/Resellers"
            )
    },
    {
        path: "/resellers/new",
        name: "NewReseller",
        component: () =>
            import(
            /* webpackChunkName: "resellers" */ "@/modules/resellers/pages/NewReseller"
            ),
        meta: {
            title: "New Reseller",
            modules: ["RESELLERS"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        }
    },
    {
        path: `/resellers/${idParam()}`,
        name: "ResellerProfile",
        meta: {
            title: "Reseller Profile",
            modules: ["RESELLERS"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "resellers" */ "@/modules/resellers/pages/ResellerProfile"
            )
    }
]